export default __webpack_public_path__ + "static/media/sales_report_line_chart.deef60f1.png";